import {all} from 'redux-saga/effects';
import AccountMemberSelectSaga from "./common/account/member/select/saga";
import AccountUserAvatarViewSaga from "./common/account/avatar/saga";
import AccountCorpLogoViewSaga from "./common/account/corp/logo/saga";
import LayoutMainSaga from "./common/layouts/main/saga";
import LayoutProfileSaga from "./common/layouts/profile/saga";
import LayoutTopBarSaga from "./common/layouts/top/saga";
import ConfirmModalSaga from "./common/confirm/saga";
import HelpMainSaga from "./help/help/list/saga";
import accountMemberInviteSaga from "./common/account/member/invite/saga";

export default function* rootSaga(getState: any): any {
    yield all([
        // ==============================
        // 通用
        // ==============================
        AccountMemberSelectSaga(), // 下拉选择账号
        AccountUserAvatarViewSaga(), // 头像查看
        AccountCorpLogoViewSaga(), // 企业图标查看
        accountMemberInviteSaga(),
        // 布局
        LayoutMainSaga(),
        LayoutProfileSaga(),
        LayoutTopBarSaga(),
        // ==============================
        // 通用
        // ==============================
        ConfirmModalSaga(),
        // ==============================
        // help
        // ==============================
        HelpMainSaga(), // sign 布局
    ]);
}
